// ACTION TYPES
export const NAV_UPDATE = '@@NAV/UPDATE';
export const NAV_SELECT = '@@NAV/SELECT';

export const navUpdate = (route, payload) => ({ type: NAV_UPDATE, payload, metadata: {route}});
export const navSelect = (route, payload) => ({ type: NAV_SELECT, payload, metadata: {route}});